import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AlertTriangle, XCircle } from 'lucide-react';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

const PaymentFailed = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [orderDetails, setOrderDetails] = useState(null);

    useEffect(() => {
        // Extract parameters from URL
        const oid = searchParams.get('oid');
        const response = searchParams.get('Response');
        const procReturnCode = searchParams.get('ProcReturnCode');
        const errMsg = searchParams.get('errMsg');

        if (oid) {
            setOrderDetails({
                oid,
                response,
                procReturnCode,
                errMsg,
                date: new Date().toLocaleDateString('fr-FR')
            });
        }
    }, [searchParams]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden">
                {/* Header - Red */}
                <div className="bg-red-500 p-6 text-center">
                    <div className="mx-auto w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm">
                        <XCircle className="w-10 h-10 text-red-500" />
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-2">Paiement Échoué</h1>
                    <p className="text-red-100">La transaction n'a pas pu être finalisée</p>
                </div>

                {/* Content */}
                <div className="p-8">
                    <div className="text-center mb-6">
                        <p className="text-gray-600">
                            Nous sommes désolés, une erreur est survenue lors du traitement de votre paiement.
                        </p>
                    </div>

                    {orderDetails && (
                        <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-gray-100">
                            <div className="space-y-3">
                                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                    <span className="text-sm text-gray-500">Référence Commande</span>
                                    <span className="font-semibold text-gray-800 text-sm">{orderDetails.oid}</span>
                                </div>
                                {orderDetails.procReturnCode && (
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm text-gray-500">Code Erreur</span>
                                        <span className="font-mono text-red-600 text-sm">{orderDetails.procReturnCode}</span>
                                    </div>
                                )}
                                {orderDetails.errMsg && (
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm text-gray-500">Message</span>
                                        <span className="font-mono text-red-600 text-xs text-right">{orderDetails.errMsg}</span>
                                    </div>
                                )}
                                <div className="flex justify-between items-center pt-2">
                                    <span className="text-sm text-gray-500">Date</span>
                                    <span className="font-medium text-gray-800">{orderDetails.date}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="bg-blue-50 text-blue-800 p-4 rounded-lg text-sm mb-6 flex items-start gap-3">
                        <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                        <p>Si le problème persiste, veuillez contacter notre support en communiquant la référence de commande.</p>
                    </div>

                    <button
                        onClick={() => navigate('/')}
                        className="w-full bg-gray-900 hover:bg-gray-800 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 flex items-center justify-center gap-2"
                    >
                        Retour à l'accueil
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailed;
